<p-dialog [visible]="visible" (visibleChange)="onVisibleChange($event)" [modal]="true" [style]="{ width: width }" [header]="title" (onHide)="onHide()">
  <ng-content></ng-content>

  @if (showFooter) {
    <ng-template pTemplate="footer">
      <p-button label="Annulla" severity="secondary" (onClick)="cancel.emit()"></p-button>
      <p-button [label]="saveLabel" [disabled]="saveDisabled" (onClick)="save.emit()"></p-button>
    </ng-template>
  }
</p-dialog>
